import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { getImages } from "../const";

gsap.registerPlugin(ScrollTrigger);

const AboutScroll = () => {
    const containerRef = useRef(null);
    const sectionsRef = useRef([]);

    useEffect(() => {
        let sections = gsap.utils.toArray(sectionsRef.current);

        gsap.to(sections, {
            xPercent: -100 * (sections.length - 1),
            ease: "none",
            scrollTrigger: {
                trigger: containerRef.current,
                pin: true,
                scrub: 1,
                snap: 1 / (sections.length - 1),
                end: "+=2500",
            },
        });

        return () => {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };
    }, []);
    return (
        <>
            <div className="smoothContainer" ref={containerRef}>
                <div className='panel' ref={(el) => (sectionsRef.current[0] = el)}>
                    <div className='panel-inner about-wrap d-flex align-items-center'>
                        <div className='about-left w-50 wow fadeInLeft' data-wow-duration="1s" data-wow-delay="0.5s">
                            <div className='position-relative d-inline-block'>
                                <img src={getImages('about-slide-1.png')} alt='about' style={{ height: '100vh' }} />
                                <div className="hd-pos">
                                    <span className='px-5'>Our Why</span>
                                </div>
                            </div>
                        </div>
                        <div className='about-right w-50 wow fadeInRight' data-wow-duration="1s" data-wow-delay="1s">
                            <div className='mxw-540'>
                                <div className='about-count mb-5'>01</div>
                                <p>Explore our curated selection of the world’s finest luxury vehicles, where cutting-edge innovation meets timeless craftsmanship. From sleek sedans to high-performance SUVs, discover the car that complements your lifestyle.</p>
                                <div className='text-end mt-120'>
                                    <a href='#' className='btn-black-theme md-btn d-inline-block'>View Inventory</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='panel' ref={(el) => (sectionsRef.current[1] = el)}>
                    <div className='panel-inner about-wrap d-flex align-items-center'>
                        <div className='about-left w-50'>
                            <div className='position-relative d-inline-block'>
                                <img src={getImages('about-slide-2.png')} alt='about' style={{ height: '100vh' }} />
                                <div className="hd-pos">
                                    <span className='px-5'>Presidential Difference</span>
                                </div>
                            </div>
                        </div>
                        <div className='about-right w-50'>
                            <div className='mxw-540'>
                                <div className='about-count mb-5'>02</div>
                                <p>Explore our curated selection of the world’s finest luxury vehicles, where cutting-edge innovation meets timeless craftsmanship. From sleek sedans to high-performance SUVs, discover the car that complements your lifestyle.</p>
                                <div className='text-end mt-120'>
                                    <a href='#' className='btn-black-theme md-btn'>View Inventory</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='panel' ref={(el) => (sectionsRef.current[2] = el)}>
                    <div className='panel-inner about-wrap d-flex align-items-center'>
                        <div className='about-left w-50'>
                            <div className='position-relative d-inline-block'>
                                <img src={getImages('about-slide-3.png')} alt='about' style={{ height: '100vh' }} />
                                <div className="hd-pos">
                                    <span className='px-5'>Unmatched Service</span>
                                </div>
                            </div>
                        </div>
                        <div className='about-right w-50'>
                            <div className='mxw-540'>
                                <div className='about-count mb-5'>03</div>
                                <p>Explore our curated selection of the world’s finest luxury vehicles, where cutting-edge innovation meets timeless craftsmanship. From sleek sedans to high-performance SUVs, discover the car that complements your lifestyle.</p>
                                <div className='text-end mt-120'>
                                    <a href='#' className='btn-black-theme md-btn'>View Inventory</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='panel' ref={(el) => (sectionsRef.current[3] = el)}>
                    <div className='panel-inner about-wrap d-flex align-items-center'>
                        <div className='about-left w-50'>
                            <div className='position-relative d-inline-block'>
                                <img src={getImages('about-slide-4.png')} alt='about' style={{ height: '100vh' }} />
                                <div className="hd-pos">
                                    <span className='px-5'>Relationships For Life</span>
                                </div>
                            </div>
                        </div>
                        <div className='about-right w-50'>
                            <div className='mxw-540'>
                                <div className='about-count mb-5'>04</div>
                                <p>Explore our curated selection of the world’s finest luxury vehicles, where cutting-edge innovation meets timeless craftsmanship. From sleek sedans to high-performance SUVs, discover the car that complements your lifestyle.</p>
                                <div className='text-end mt-120'>
                                    <a href='#' className='btn-black-theme md-btn'>View Inventory</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutScroll